import { useSelector } from "react-redux";

// Dynamic bucket modes (2026-06-22): one source of truth for the current tenant's
// enabled analytics granularity modes, read from metaData.analyticsModes (populated
// at app load from GET /aggregation/modes). Backs the rolling-rule + chart selectors
// so a tenant is only offered granularities whose buckets actually exist for it.

// Display order (ascending window length) + human labels. Unknown modes sort last
// and fall back to their raw value as the label, so a future backend mode (e.g.
// "12h") still renders sensibly without an FE change.
export const MODE_ORDER = { hourly: 1, "4h": 4, "8h": 8, "12h": 12, daily: 24, weekly: 168, monthly: 720, yearly: 8760 };
export const MODE_LABELS = { hourly: "Hourly", "4h": "4-Hourly", "8h": "8-Hourly", "12h": "12-Hourly", daily: "Daily", weekly: "Weekly", monthly: "Monthly", yearly: "Yearly" };

export const modeLabel = (m) => MODE_LABELS[m] || m;
export const sortModes = (modes) =>
  [...(modes || [])].sort((a, b) => (MODE_ORDER[a] || 999) - (MODE_ORDER[b] || 999));

// hourly + daily are always effective (hot path + universal baseline rollup), so a
// not-yet-loaded / empty modes list still renders the historical selector options.
const FALLBACK = ["hourly", "daily"];

const useAnalyticsModes = () => {
  const modes = useSelector((state) => state.metaData && state.metaData.analyticsModes);
  return sortModes(modes && modes.length ? modes : FALLBACK);
};

export default useAnalyticsModes;
